import { Chip, Stack, Typography } from '@mui/material'
import { type FC, type ReactNode } from 'react'

type Props = {
  label: string
  htmlFor?: string
  required?: boolean
  children: ReactNode
}

export const LabeledField: FC<Props> = ({
  label,
  htmlFor,
  required = false,
  children,
}) => {
  return (
    <Stack gap={1}>
      <Typography
        htmlFor={htmlFor}
        component="label"
        sx={{
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {label}
        {!required && <Chip label="任意" size="small" variant="outlined" />}
      </Typography>
      {children}
    </Stack>
  )
}
